import { ChangeSummaryCategory } from '@components/ncFileVersions/components/NCFileDiffView/constants/classifyChanges.constants';

export const SUMMARY_ENTRY_TEST_ID_PREFIX = 'change-summary-entry-';

export const COLLAPSED_STRIP_MIN_HEIGHT = 44;
export const EXPANDED_MAX_HEIGHT = 360;
export const HIGHLIGHT_DURATION_MS = 600;
export const CATEGORY_DOT_SIZE = 8;
export const CHIP_GAP = 12;

// Responsive entry grid inside an expanded category section. Items aim for a
// minimum visual width; column count derives from the measured container width.
export const ENTRY_GRID_MIN_ITEM_WIDTH = 220;
export const ENTRY_GRID_MAX_COLUMNS = 4;
export const ENTRY_GRID_GAP = 8;

export const CATEGORY_DISPLAY_ORDER: ChangeSummaryCategory[] = [
  ChangeSummaryCategory.TOOL,
  ChangeSummaryCategory.M_CODE,
  ChangeSummaryCategory.FEED_RATE,
  ChangeSummaryCategory.SPINDLE_SPEED,
  ChangeSummaryCategory.RADIUS_COMP,
  ChangeSummaryCategory.COORDINATE,
  ChangeSummaryCategory.POLAR,
  ChangeSummaryCategory.CYCLE_CODE,
  ChangeSummaryCategory.PARAMETER,
  ChangeSummaryCategory.COMMENT,
];

export const CATEGORY_TITLE_KEY: Record<ChangeSummaryCategory, string> = {
  [ChangeSummaryCategory.TOOL]: 'Tool changes',
  [ChangeSummaryCategory.M_CODE]: 'M-code changes',
  [ChangeSummaryCategory.FEED_RATE]: 'Feed-rate changes',
  [ChangeSummaryCategory.SPINDLE_SPEED]: 'Spindle-speed changes',
  [ChangeSummaryCategory.RADIUS_COMP]: 'Radius compensation changes',
  [ChangeSummaryCategory.COORDINATE]: 'Coordinate adjustments',
  [ChangeSummaryCategory.POLAR]: 'Polar coordinate changes',
  [ChangeSummaryCategory.CYCLE_CODE]: 'Cycle codes',
  [ChangeSummaryCategory.PARAMETER]: 'Parameter changes',
  [ChangeSummaryCategory.COMMENT]: 'Comment edits',
};

// Only 4 NC marked tokens exist; non-motion programmatic categories (M-code,
// radius comp, cycle, parameter) share Label/Tertiary, comments fall through
// to Quaternary. Polar reuses the COORDINATE color since both are geometry.
export const CATEGORY_COLOR_TOKEN: Record<ChangeSummaryCategory, string> = {
  [ChangeSummaryCategory.TOOL]: 'NC File Comparison/Light/Marked Character Right',
  [ChangeSummaryCategory.M_CODE]: 'Label/Light/Tertiary',
  [ChangeSummaryCategory.FEED_RATE]: 'NC File Comparison/Light/Marked Section Right',
  [ChangeSummaryCategory.SPINDLE_SPEED]: 'NC File Comparison/Light/Marked Character Left',
  [ChangeSummaryCategory.RADIUS_COMP]: 'Label/Light/Tertiary',
  [ChangeSummaryCategory.COORDINATE]: 'NC File Comparison/Light/Marked Section Left',
  [ChangeSummaryCategory.POLAR]: 'NC File Comparison/Light/Marked Section Left',
  [ChangeSummaryCategory.CYCLE_CODE]: 'Label/Light/Tertiary',
  [ChangeSummaryCategory.PARAMETER]: 'Label/Light/Tertiary',
  [ChangeSummaryCategory.COMMENT]: 'Label/Light/Quaternary',
};
